import { Locale } from './utilities';

export const urls = {
  home: {
    en: 'https://yogainternational.zendesk.com/hc/en-us',
    es: 'https://yogainternational.zendesk.com/hc/es',
  },
  contact_us: {
    en: 'https://yogainternational.zendesk.com/hc/en-us/articles/16424907927835-Contacting-Yoga-International-',
    es: 'https://yogainternational.zendesk.com/hc/es/articles/16424907927835-Contactar-a-Yoga-Internacional',
  },
  active_membership_info: {
    en: 'https://yogainternational.zendesk.com/hc/en-us/articles/15574808559387-Active-Membership-Details-Changes-and-Reactivation',
    es: undefined,
  },
  account_deletion: {
    en: 'https://yogainternational.zendesk.com/hc/en-us/articles/16425043670555-Account-Deletion-Request-',
    es: undefined,
  },
  cancel_membership: {
    en: 'https://yogainternational.zendesk.com/hc/en-us/articles/16434800254363-Cancel-Membership-',
    es: 'https://yogainternational.zendesk.com/hc/es/articles/16434800254363-Cancelar-tu-membres%C3%ADa',
  },
  membership_trial_faq: {
    en: 'https://yogainternational.zendesk.com/hc/en-us/articles/15376792036891-Free-Trial-and-Membership-FAQ',
    es: 'https://yogainternational.zendesk.com/hc/es/articles/15376792036891-Prueba-gratuita-y-FAQs-sobre-la-membres%C3%ADa',
  },
  video_microphone_troubleshooting: { en: undefined, es: undefined },
};

// Validate that all localizations are represented above
type LocalizedUrl = { [K in Locale]: undefined | string };
type Validate<T extends { [K in keyof typeof urls]: LocalizedUrl }> = T;
export type Validated = Validate<typeof urls>;

export const getHelpCenterUrl = (name: keyof typeof urls, locale: Locale): string =>
  urls[name]?.[locale] || urls[name]?.en || '';
